import { render, staticRenderFns } from "./Club.vue?vue&type=template&id=4994fa68&"
import script from "./Club.vue?vue&type=script&lang=js&"
export * from "./Club.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports